var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMultiSelectFillHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.94281 2.03687H1.95809C1.69338 2.03687 1.43951 2.14194 1.25233 2.32899C1.06516 2.51603 0.96 2.76971 0.96 3.03423V15.9999L5.95045 13.4797L10.9409 15.9999V3.03423C10.9409 2.76971 10.8357 2.51603 10.6486 2.32899C10.4614 2.14194 10.2075 2.03687 9.94281 2.03687Z",
    fill: "#891515"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2244 12.3465V0.997697H4.24285H3.24516C3.24516 0.733091 3.35027 0.479323 3.53737 0.292219C3.72448 0.105114 3.97825 0 4.24285 0H12.2244C12.489 0 12.7428 0.105114 12.9299 0.292219C13.117 0.479323 13.2221 0.733091 13.2221 0.997697V13.9678L12.2244 12.3465Z",
    fill: "#891515"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiSelectFillHover);
export default __webpack_public_path__ + "static/media/multi_select_fill_hover.eec8b2f91d860074bfd0e6533d372137.svg";
export { ForwardRef as ReactComponent };